/** KAN-647: статистика A/B вариантов первого сообщения Telegram-аутрича. */
import { useQuery } from '@tanstack/react-query';
import { greetingAbApi } from '@/services/api/greetingAb';

export const GREETING_AB_QUERY_KEY = ['telegram-greeting-ab'] as const;

/** KAN-752: ключ статистики одного оператора (без него - вся организация). */
export function greetingAbKey(operatorId?: string) {
  return [...GREETING_AB_QUERY_KEY, operatorId ?? 'all'] as const;
}

export function useGreetingAb(operatorId?: string) {
  return useQuery({
    queryKey: greetingAbKey(operatorId),
    queryFn: () => greetingAbApi.get(operatorId),
    staleTime: 60_000,
  });
}

export default useGreetingAb;
